export function withSearchQuery(href: string, search: string, searchKey = 'q') {
  const normalizedSearch = search.trim();

  if (!normalizedSearch) {
    return href;
  }

  const params = new URLSearchParams({ [searchKey]: normalizedSearch });

  return `${href}?${params.toString()}`;
}
